import { Box, Chip, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { INegotiationHistoryEntry } from "../../../shared/services/api/sinister/AgreementRenegotiationService";
import { formatDateFnsRemoveTimezone } from "../../../shared/utils/format-date";
import { formatScaleValueBR } from "../../../shared/utils/formatScaleValue";
import { getNegotiationAgreementStatusChipColors, getNegotiationAgreementStatusLabel } from "../constants/negotiationStatusOptions";

interface Props {
	history: INegotiationHistoryEntry[];
}

const sectionTitleSx = { mb: 1.5, textTransform: "uppercase" as const };

// Histórico dos acordos da mesma negociação (renegociações anteriores) — fica no final da página
// de detalhe, depois dos dados do acordo atual, já que é um registro do passado, não algo do acordo em si.
export const AgreementNegotiationHistorySection = ({ history }: Props) => {
	if (history.length === 0) return null;

	return (
		<>
			<Divider />
			<Box>
				<Typography variant="subtitle2" color="primary" fontWeight={700} sx={sectionTitleSx}>
					Histórico de Acordos
				</Typography>
				<TableContainer>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Acordo</TableCell>
								<TableCell align="center">Status</TableCell>
								<TableCell align="right">Valor</TableCell>
								<TableCell align="center">Criado em</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{history.map((entry) => {
								const colors = getNegotiationAgreementStatusChipColors(entry.status);
								return (
									<TableRow
										key={entry.id}
										hover
										sx={{ cursor: "pointer" }}
										onClick={() => window.open(`/sinistros/acordos/detalhe/${entry.id}`, "_blank", "noopener")}
									>
										<TableCell>{entry.id}</TableCell>
										<TableCell align="center">
											<Chip
												size="small"
												label={getNegotiationAgreementStatusLabel(entry.status)}
												sx={{ bgcolor: colors.bg, color: colors.color, fontWeight: 500 }}
											/>
										</TableCell>
										<TableCell align="right">{formatScaleValueBR(String(entry.totalValue))}</TableCell>
										<TableCell align="center">{formatDateFnsRemoveTimezone(entry.createdAt) || "-"}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</>
	);
};
